import Vue from 'vue'
import './plugins/vuetify'
import './plugins/highcharts'
import './plugins/iview'
import router from './plugins/router'
import App from './App.vue'
import ApiClient from './services/ApiClient'
import AuthService from "./services/AuthService"
import "./filters/shortName"
import "./filters/dateOnly"
import "./filters/decimal"
import "./directives/scroll"

Vue.config.productionTip = false

Vue.use(AuthService, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientID: process.env.VUE_APP_AUTH0_CLIENTID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECTURI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  responseType: 'token id_token',
  redirect: false,
  scope: 'openid'
});

Vue.use(ApiClient, {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  authService: Vue.authService
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
